<ng-container [formGroup]="form">
  @for (formItem of dynamicFormFields; track formItem) {
    <app-dynamic-form-child [formItem]="formItem" [errorState]="errorState"></app-dynamic-form-child>
  }
</ng-container>
